import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { Messages } from '~src/codegen/Localize';
import { editPredictiveModel } from '~src/predictiveModel/actions/EditPredictiveModelReduxAction';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { ILaunchWebAuthoringAction } from '~src/spacesPlatform/models/actionNames';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

export const EditPredictiveModelEntityAction: IEntityAction<IContentInfo<'predictiveModel'>, ILaunchWebAuthoringAction> = {
  name: EntityActionNames.EditPredictiveModel,
  translateName: Messages.editPredictiveModel,
  isVisible: () => FeatureFlags.prometheusPredictiveModelEnabled,
  isClickable: (availableActions: ILaunchWebAuthoringAction) => !!(availableActions && availableActions.launchWebAuthoring),
  createReduxAction: (targetItems: IContentInfo[]) => editPredictiveModel(targetItems[0])
};

